import { footerChannels, footerAbout } from "@/mocks/home";

export default function Footer() {
  return (
    <footer className="w-full border-t border-background-300 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-[1.3fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2">
              <div className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-eye-2-line" />
              </div>
              <h3 className="font-heading text-xl font-black tracking-wide text-foreground-950">看黑料</h3>
            </div>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-foreground-500">
              聚合全网最新黑料新爆料，看黑料今日曝光实时更新，满足你对新鲜内幕的追踪需求。
            </p>
            <div className="mt-4 flex items-center gap-2 text-foreground-500">
              {["ri-wechat-line", "ri-weibo-line", "ri-tv-2-line"].map((ic) => (
                <a
                  key={ic}
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  aria-label="社交入口"
                  className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-background-200/70 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={ic} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950">热门栏目</h4>
            <ul className="mt-3 grid grid-cols-2 gap-2">
              {footerChannels.map((c) => (
                <li key={c}>
                  <a
                    href="#"
                    onClick={(e) => e.preventDefault()}
                    className="cursor-pointer text-sm text-foreground-500 transition-colors hover:text-primary-600"
                  >
                    {c}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950">站务合作</h4>
            <ul className="mt-3 grid grid-cols-1 gap-2">
              {footerAbout.map((c) => (
                <li key={c}>
                  <a
                    href="#"
                    onClick={(e) => e.preventDefault()}
                    className="cursor-pointer text-sm text-foreground-500 transition-colors hover:text-primary-600"
                  >
                    {c}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950">热线与服务</h4>
            <ul className="mt-3 flex flex-col gap-2 text-sm text-foreground-500">
              <li className="flex items-center gap-1.5">
                <i className="ri-time-line text-primary-500" />
                编辑部 7×24 小时在线
              </li>
              <li className="flex items-center gap-1.5">
                <i className="ri-mail-line text-primary-500" />
                tips@kanheiliao.example
              </li>
              <li className="flex items-center gap-1.5">
                <i className="ri-phone-line text-primary-500" />
                400-XXX-XXXX（举报与线索）
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-5 text-xs text-foreground-400 sm:flex-row">
          <p className="text-center sm:text-left">
            © {new Date().getFullYear()} 看黑料 · 本页为模板演示内容，全部线索均为示意素材，不代表任何事实。
          </p>
          <p className="flex items-center gap-1.5 whitespace-nowrap">
            认准看黑料今日曝光入口
            <i className="ri-flashlight-fill text-primary-500" />
          </p>
        </div>
      </div>
    </footer>
  );
}